import client from '@/api/client';
import { gql } from '@apollo/client';

const setCommentToCard = (
  comment: string,
  listId: number,
) => client
  .mutate({
    mutation: gql`
      mutation(
        $comment: String,
        $listId: Int
      ) {
        setCommentToCard(
          comment: $comment,
          listId: $listId
        ) {
          status
        }
      }
    `,
    variables: {
      comment,
      listId,
    },
  });

const deleteStudentFromList = (
  listId: number,
) => client
  .mutate({
    mutation: gql`
      mutation(
        $listId: Int
      ) {
        deleteStudentFromList(
          listId: $listId
        ) {
          status
        }
      }
    `,
    variables: {
      listId,
    },
  });

const updateStudent = (
  listId: number,
  courseId?: number,
  englishLevel?: number,
  schedule?: string,
) => client
  .mutate({
    mutation: gql`
      mutation($studentListData: UpdateStudentListInput) {
        updateStudentList(studentListData: $studentListData) {
          status
        }
      }
    `,
    variables: {
      studentListData: {
        courseId,
        englishLevel,
        schedule,
        listId,
      },
    },
  });

export default {
  setCommentToCard,
  deleteStudentFromList,
  updateStudent,
};
